import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers";
export default function useKeywordsRanklvl2GridColumns(): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "keyword",
            checkboxSelection: true,
            headerName: formatMessage({ id: "keywords.grid.col.keyword" }),
            width: 200,
            pinned: "left",
            filter: "agTextColumnFilter",
            filterParams: {
                suppressAndOrCondition: true,
                filterOptions: ["contains", "equals", "notContains"],
            },
        },
        {
            field: "lang",
            headerName: formatMessage({ id: "keywords.grid.col.lang" }),
            minWidth: 50,
            maxWidth: 50,
            pinned: "left",
            filter: "agTextColumnFilter",
            filterParams: {
                suppressAndOrCondition: true,
                filterOptions: ["contains", "equals", "notContains"],
            },
            cellRenderer: ({ data }: any) => {
                if (!data.lang) return <></>;
                return (
                    <SVG
                        width={16}
                        src={toAbsoluteUrl(`/media/flags/${data.lang.toLowerCase()}.svg`)}
                    />
                );
            },
        },
        {
            field: "volume",
            headerName: formatMessage({ id: "keywords.grid.col.volume" }),
            filter: "agNumberColumnFilter",
            filterParams: {
                suppressAndOrCondition: true,
                filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
            },
            minWidth: 80,
            maxWidth: 80,
            pinned: "left",
            cellClass: "number-cell",
        },
        {
            field: "kd",
            headerName: formatMessage({ id: "keywords.grid.col.kd" }),
            filter: "agNumberColumnFilter",
            filterParams: {
                suppressAndOrCondition: true,
                filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
            },
            minWidth: 60,
            maxWidth: 60,
            cellClass: "number-cell",
        },
        {
            field: "thematic",
            headerName: formatMessage({ id: "keywords.grid.col.thematic" }),
            minWidth: 107,
            maxWidth: 107,
            filter: "agTextColumnFilter",
            filterParams: {
                suppressAndOrCondition: true,
                filterOptions: ["contains", "equals", "notContains"],
            },
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos10" }),
            children: [
                {
                    field: "pos10.bl",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.bl" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos10?.bl || 0} (${data?.pos10?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                },
                {
                    field: "pos10.words",
                    minWidth: 65,
                    maxWidth: 65,
                    headerName: formatMessage({ id: "keywords.grid.col.words" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos10?.words ? data.pos10?.words : 0),
                    hide: true,
                },
                {
                    field: "pos10.traffic",
                    minWidth: 80,
                    maxWidth: 80,
                    headerName: formatMessage({ id: "keywords.grid.col.traffic" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        data.pos10?.traffic ? data.pos10?.traffic : 0,
                },
                {
                    field: "pos10.da",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.da" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos10?.da ? data.pos10?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                },
            ],
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos11" }),
            children: [
                {
                    field: "pos11.bl",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.bl" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos11?.bl || 0} (${data?.pos11?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                },
                {
                    field: "pos11.words",
                    minWidth: 65,
                    maxWidth: 65,
                    headerName: formatMessage({ id: "keywords.grid.col.words" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos11?.words ? data.pos11?.words : 0),
                    hide: true,
                },
                {
                    field: "pos11.traffic",
                    minWidth: 80,
                    maxWidth: 80,
                    headerName: formatMessage({ id: "keywords.grid.col.traffic" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        data.pos11?.traffic ? data.pos11?.traffic : 0,
                },
                {
                    field: "pos11.da",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.da" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos11?.da ? data.pos11?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                },
            ],
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos12" }),
            children: [
                {
                    field: "pos12.bl",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.bl" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos12?.bl || 0} (${data?.pos12?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                },
                {
                    field: "pos12.words",
                    minWidth: 65,
                    maxWidth: 65,
                    headerName: formatMessage({ id: "keywords.grid.col.words" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos12?.words ? data.pos12?.words : 0),
                    hide: true,
                },
                {
                    field: "pos12.traffic",
                    minWidth: 80,
                    maxWidth: 80,
                    headerName: formatMessage({ id: "keywords.grid.col.traffic" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        data.pos12?.traffic ? data.pos12?.traffic : 0,
                },
                {
                    field: "pos12.da",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.da" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos12?.da ? data.pos12?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                },
            ],
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos14" }),
            children: [
                {
                    field: "pos14.bl",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.bl" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos14?.bl || 0} (${data?.pos14?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                },
                {
                    field: "pos14.words",
                    minWidth: 65,
                    maxWidth: 65,
                    headerName: formatMessage({ id: "keywords.grid.col.words" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos14?.words ? data.pos14?.words : 0),
                    hide: true,
                },
                {
                    field: "pos14.traffic",
                    minWidth: 80,
                    maxWidth: 80,
                    headerName: formatMessage({ id: "keywords.grid.col.traffic" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        data.pos14?.traffic ? data.pos14?.traffic : 0,
                },
                {
                    field: "pos14.da",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.da" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos14?.da ? data.pos14?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                },
            ],
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos15" }),
            children: [
                {
                    field: "pos15.bl",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.bl" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos15?.bl || 0} (${data?.pos15?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                },
                {
                    field: "pos15.words",
                    minWidth: 65,
                    maxWidth: 65,
                    headerName: formatMessage({ id: "keywords.grid.col.words" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos15?.words ? data.pos15?.words : 0),
                    hide: true,
                },
                {
                    field: "pos15.traffic",
                    minWidth: 80,
                    maxWidth: 80,
                    headerName: formatMessage({ id: "keywords.grid.col.traffic" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) =>
                        data.pos15?.traffic ? data.pos15?.traffic : 0,
                },
                {
                    field: "pos15.da",
                    minWidth: 60,
                    maxWidth: 60,
                    headerName: formatMessage({ id: "keywords.grid.col.da" }),
                    filter: "agNumberColumnFilter",
                    filterParams: {
                        suppressAndOrCondition: true,
                        filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
                    },
                    cellClass: "number-cell",
                    valueFormatter: ({ data }: any) => (data.pos15?.da ? data.pos15?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                },
            ],
        },
    ];

    return gridColumns;
}
